import logo from "./logo.svg";
import "./App.css";
import Sidebar from "./components/Sidebar";
import Home from "./pages/Home";

function App() {
  return (
    <div>
      <Sidebar />
      <Home />
    </div>
  );
}

export default App;
